(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kk-overlay-header"] && !Shopify.designMode) return;
  try {
    function initialiseKkOverlay() {
    const header = document.querySelector('store-header.kk-overlay');
    if (!header || header.dataset.kkReady) return;
    header.dataset.kkReady = 'true';
    const update = () => {
      if (!header.isConnected) return;
      const height = header.querySelector('.header__grid').getBoundingClientRect().height + (matchMedia('(max-width: 768.98px)').matches ? 16 : 20);
      document.documentElement.style.setProperty('--kk-header-height', `${height}px`);
      header.classList.toggle('kk-scrolled', window.scrollY > 48);
    };
    const observer = new ResizeObserver(update);
    observer.observe(header.querySelector('.header__logo'));
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    document.addEventListener('shopify:section:unload', (event) => {
      if (!event.target.contains(header)) return;
      observer.disconnect();
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    });
    update();
  }
  initialiseKkOverlay();
  document.addEventListener('shopify:section:load', initialiseKkOverlay);
  } catch(e) { console.error(e); }
})();

})();
